import { Action, initialState, State } from "store/store";

export const updateCourseTheme = (
  state: State = initialState,
  { data }: Action
): State => {
  const nextState = {
    ...state,
    theme: {
      ...(state as any).theme,
      ...data,
    },
  };

  return nextState;
};